import TextButton from 'components/Luxkit/Button/TextButton'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import { pluralizeToString } from 'lib/pluralize'
import React from 'react'
import OfferCapacityWithAgesVerticalSelection from '../../CapacityWithAges/OfferCapacityWithAgesVerticalSelection'

interface Props {
  maxGuests: number;
  onClose?: () => void;
  capacities?: Array<App.PackageRoomCapacity>;
  occupantUnit?: 'guest' | 'traveller';
  disableMultiRoom?: boolean;
  childrenAgeLabel?: string;
}

function OfferCalendarCapacitySelectDropdown(props: Props) {
  const {
    maxGuests,
    capacities,
    occupantUnit = 'guest',
    onClose,
    childrenAgeLabel = 'at time of check-in',
    disableMultiRoom,
  } = props
  return <DropdownContainer
    title="Who is going?"
    subtitle={maxGuests > 0 ? `Maximum occupancy is ${pluralizeToString(occupantUnit, maxGuests)}` : undefined}
    onClose={onClose}
    footer={ <TextButton
      kind="primary"
      onClick={onClose}
      fit="full-width"
      size="large"
    >
      Apply
    </TextButton>}
  >
    <OfferCapacityWithAgesVerticalSelection
      capacities={capacities}
      childrenAgeLabel={childrenAgeLabel}
      disableMultiRoom={disableMultiRoom}
    />
  </DropdownContainer>
}

export default OfferCalendarCapacitySelectDropdown
